import React, { useContext } from 'react'
import styled from 'styled-components'
import { animated } from 'react-spring'

import Button from '../components/Button'
import { flexBoxStyles } from '../components/Flexbox'

import withPermissions from '../containers/withPermissions'

import Home from '../images/dashboardIcon'
import PatientIcon from '../images/patientIcon'
import PostDiagnosticIcon from '../images/postDiagnosticIcon'
import UnitsIcon from '../images/officeGray'
import SurveysIcon from '../images/surveysIcon'
import StatsIcon from '../images/statsIcon'
import Logout from '../images/logoutIcon'

import colors from '../styles/colors'
import Link from './Link'
import logo from '../images/logo.svg'
import { permissions as p } from '../utils/constants'
import { Session } from '../containers/Session/Session'
import { AppContext } from '../containers/App'
import { Hidden } from '../styles/Shared'

const decorate = withPermissions

const Header = ({ siteTitle, sidebarWidth, hasPermissions, logout }) => {
  const user = useContext(AppContext)
  return (
    <HeaderWrapper style={{ paddingRight: sidebarWidth }}>
      <LogoWrapper align="center">
        <StyledLink
          to="/"
          style={{
            color: 'white',
          }}
        >
          <Logo alt="Kompleksowa Analiza Procesów Poznawczych" src={logo} />
        </StyledLink>
      </LogoWrapper>
      <Session />
      <NavWrapper>
        <List>
          <li>
            <StyledLink to="/app">
              <Home ariaHidden={true} />
              Pulpit
            </StyledLink>
          </li>
          {hasPermissions(p.diagnostician) && user.unitId !== null && (
            <li>
              <StyledLink to="/app/patients">
                <PatientIcon ariaHidden={true} />
                Osoby diagnozowane
              </StyledLink>
            </li>
          )}
          {hasPermissions(p.diagnostician) && user.unitId !== null && (
            <li>
              <StyledLink to="/app/post-diagnostic">
                <PostDiagnosticIcon ariaHidden={true} />
                Materiały wspierające diagnozę i postdiagnostyczne
              </StyledLink>
            </li>
          )}
          {hasPermissions(p.diagnosticiansManagement) && user.unitId !== null && (
            <li>
              <StyledLink to="/app/surveys">
                <SurveysIcon ariaHidden={true} />
                Ankiety
              </StyledLink>
            </li>
          )}
          {hasPermissions(p.diagnosticiansManagement) &&
            (user.unitId !== null || user.userLevel === 9) && (
              <li>
                <StyledLink to="/app/units">
                  <UnitsIcon ariaHidden={true} />
                  {user.userLevel === 3 ? 'Diagności' : 'Jednostka'}
                </StyledLink>
              </li>
            )}
          {hasPermissions(p.diagnosticiansManagement) &&
            (user.unitId !== null || user.userLevel === 9) && (
              <li>
                <StyledLink to="/app/statistics">
                  <StatsIcon ariaHidden={true} />
                  Statystyki
                </StyledLink>
              </li>
            )}
          <li>
            <Button color="plain" onClick={logout}>
              <LogoutWrapper>
                <Logout ariaHidden={true} />
                <Hidden>Wyloguj</Hidden>
              </LogoutWrapper>
            </Button>
          </li>
        </List>
      </NavWrapper>
    </HeaderWrapper>
  )
}

const LogoutWrapper = styled.span`
  display: block;
  svg g {
    fill: ${colors.light_black};
  }
`;

const LogoWrapper = styled.div`
  ${flexBoxStyles}
`
const Logo = styled.img`
  width: 180px;
`

const HeaderWrapper = styled(animated.header)`
  padding-left: 15px;
  background: #fff;
  position: fixed;
  width: 100%;
  top: 0;
  border-bottom: 1px solid #e6ecf1;
  z-index: 4;
  height: 70px;
  img {
    margin-bottom: 0;
    height: 50px;
  }
  display: flex;
  flex: 1 1;
  justify-content: space-between;
`

const NavWrapper = styled.nav`
  display: flex;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  margin: 0 5px;
  display: flex;
  align-items: center;
`

const List = styled.ul`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  img {
    height: 25px;
  }
  list-style: none;
  margin: 0;
  > li {
    font-size: 0.75rem;
    display: flex;
    margin: 0;
    height: 100%;

    > a {
      display: flex;
      flex: 1 0;
      align-items: center;
      justify-content: space-evenly;
      color: ${colors.light_black};
      &:hover {
        color: ${colors.dark_monza};

        svg > g > g {
          fill: ${colors.dark_monza};
        }
      }
      &.active {
        color: ${colors.monza};
        svg > g > g {
          fill: ${colors.monza};
        }
      }
      > button {
        &:hover {
          svg > g {
            fill: ${colors.dark_monza};
          }
        }
        &.active {
          color: ${colors.monza};
          svg > g > g {
            fill: ${colors.monza};
          }
        }
      }

      svg {
        margin-right: 5px;
      }
    }
  }
`

export default decorate(Header)
